import cookies from './index';

const setValue = async (name: string, value: string) => {
  cookies.set(name, value, { path: '/' });
};

export default { setValue };
